import React from 'react';
import {Link} from 'react-router-dom';

class Menu extends React.Component {
  render() {
    return (
      <aside className="main-sidebar">
        <section className="sidebar">
            <ul className="sidebar-menu">
              {
                this.props.links.map((link, i)=>{
                  if(link.tipo === 'unico'){
                    return (
                      <li key={"l" + i} className={this.props.path === link.rota ? 'active' : null}>
                        <Link to={link.rota}>
                          <i className={`fa ${link.icone} fa-fw`}></i>
                          <span>{link.span}</span>
                        </Link>
                      </li>
                    )
                  } else if(link.tipo === 'dropdown'){
                    return (
                      <li key={"l" + i} className={link.sublinks.filter((link)=>{return link.rota  === this.props.path}).length ===1  ? 'active treeview': "treeview"}>
                        <a role="button">
                          <i className={`fa ${link.icone} fa-fw`}></i>
                          <span>{link.span}</span>
                          <span className="pull-right-container">
                            <i className="fa fa-angle-left pull-right"></i>
                          </span>
                        </a>
                        <ul className="treeview-menu">
                          {
                            link.sublinks.map((sublink, j)=>(
                              <li key={"s" + i + j} className={this.props.path == sublink.rota ? 'active' : null}>
                                <Link to={sublink.rota}>
                                  <i className={`fa ${sublink.icone} fa-fw`}></i>
                                  <span>{sublink.span}</span>
                                </Link>
                              </li>
                            ))
                          }
                        </ul>
                      </li>
                    )
                  }
                })
              }
            </ul>
        </section>
      </aside>
    );
  }
}

export default (Menu);



// WEBPACK FOOTER //
// ./src/components/Menu.js